import { Component } from '@angular/core';

@Component({
  selector: 'fl-modal-content',
  template: `
    <div>THIS IS A SCROLLING CONTAINER</div>
    <div><ng-content></ng-content></div>
    <div>OR WHATHER</div>
  `,
  styleUrls: ['./modal-content.component.scss'],
})
export class ModalContentComponent {}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/pl/webapp/src/app/@shared/ui/modal/modal-content.component.ts